import { Injectable, inject } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  private toastService = inject(ToastrService);

  showSuccessMessage(message: string): void {
    this.toastService.success(message, 'Success', {
      timeOut: 5000,
      positionClass: 'toast-top-right',
      closeButton: true,
      progressBar: true,
      progressAnimation: 'increasing',
      enableHtml: true,
      extendedTimeOut: 10000,
    });
  }

  showErrorMessage(errorMessage: string): void {
    this.toastService.error(errorMessage, 'Error', {
      timeOut: 5000,
      positionClass: 'toast-top-right',
      closeButton: true,
      progressBar: true,
      progressAnimation: 'increasing',
      enableHtml: true,
      extendedTimeOut: 10000,
    });
  }
}
